import moment from 'moment'

/**
 * Assorted General Mixinss
 */
export const mixin = {
  filters: {
    // Pad a number (such as a Job ID) with leading zeros, to a length of 5 chars
    padFour (value) {
      if (value) {
        return ('0000' + value).substr(-4)
      } else {
        return ''
      }
    },
    localiseUTCDate (date) {
      return moment.utc(date).local().format('D/M/YY')
    },
    formatCurrency (number) {
      if (number < 0) {
        return '-$' + (-number).toLocaleString('en-AU')
      } else {
        return '$' + number.toLocaleString('en-AU')
      }
    },
    formatDateLong (date) {
      // Add the Year to the date format if incoming date is not the current year
      let dateFormat = (moment(date).year() !== moment().year()) ? 'ddd Do MMM YYYY' : 'ddd Do MMMM'
      return moment(date).format(dateFormat)
    },
    secondsToHours (seconds) {
      if (seconds > 0) {
        return Math.round(seconds / 60 / 60)
      }
      return 0
    }
  }
}

